module.exports = __webpack_public_path__ + "img/jyW.305edde2.png";